import { memo } from 'react';
import { Icon, NavigationIcon } from '@cbhq/cds-web/icons';
import { SpotSquare, SpotIcon, Pictogram } from '@cbhq/cds-web/illustrations';
import { jsx } from 'react/jsx-runtime';
function SubLinkIcon({
  item
}) {
  const iconType = item.iconType,
    iconName = item.iconName,
    intlLabelKey = item.intlLabelKey;
  if (iconType === 'spotSquare') {
    return /*#__PURE__*/jsx(SpotSquare, {
      testID: `${intlLabelKey}-spot-square`,
      name: iconName,
      scaleMultiplier: 0.3334
    });
  }
  if (iconType === 'spotIcon') {
    return /*#__PURE__*/jsx(SpotIcon, {
      testID: `${intlLabelKey}-spot-icon`,
      name: iconName
    });
  }
  if (iconType === 'pictogram') {
    return /*#__PURE__*/jsx(Pictogram, {
      testID: `${intlLabelKey}-pictogram`,
      name: iconName,
      scaleMultiplier: 0.5,
      dimension: "64x64"
    });
  }
  if (iconType === 'icon') {
    return /*#__PURE__*/jsx(Icon, {
      testID: `${intlLabelKey}-icon`,
      name: iconName,
      size: "s",
      color: "foreground"
    });
  }
  return /*#__PURE__*/jsx(NavigationIcon, {
    testID: `${intlLabelKey}-navigation-icon`,
    size: "l",
    name: "coinbase"
  });
}
const SublinkIcon = /*#__PURE__*/memo(SubLinkIcon);
export { SublinkIcon as default };
//# sourceMappingURL=SublinkIcon.js.map
